import { render, staticRenderFns } from "./VDetailsInnerForm.vue?vue&type=template&id=11af4ead"
import script from "./VDetailsInnerForm.vue?vue&type=script&lang=js"
export * from "./VDetailsInnerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports